import { memo, useMemo } from 'react';
import SelectMicrophone from './SelectMicrophone';
import GateRelays from './GateRelays';

import PropTypes from 'prop-types';

import styles from './GateActions.module.css';

const GateActions = ({ relayConfig, transactionId }) => {
    const orderedRelayConfig = useMemo(() => {
        if (!relayConfig?.length) return relayConfig;
        return [...relayConfig].sort((a, b) => (a.relaySlotId ?? 0) - (b.relaySlotId ?? 0));
    }, [relayConfig]);

    return (
        <div className={styles['camera-stream-window-gate--actions']}>
            <SelectMicrophone />
            <GateRelays relayConfig={orderedRelayConfig} transactionId={transactionId} />
        </div>
    );
};

GateActions.propTypes = {
    transactionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    relayConfig: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            relayNumber: PropTypes.number.isRequired,
            relaySlotId: PropTypes.number.isRequired,
            signalLabels: PropTypes.arrayOf(
                PropTypes.shape({
                    active: PropTypes.bool.isRequired,
                    label: PropTypes.string.isRequired,
                    operation: PropTypes.string.isRequired,
                })
            ).isRequired,
        })
    ),
};

export default memo(GateActions);
